import Base from '../Base';

export default class Task extends Base {
  constructor(item) {
    super(item.id, '/tasks');

    this.attempt = item.attempt;
    this.user_attempts = item.user_attempts;
    this.title = item.title;
    this.description = item.description;
    this.created_at = item.created_at;
    this.mark = item.mark;
    this.status = item.status;
    this.type = item.type;
    this.updated_at = item.updated_at;
  }
}
